<template>
  <div>
    <div class="bg-hrad">
      <div class="container">
        <div class="header-mcct">
          <img width="156px" height="42px" src="@/assets/img/mpos-white.png" />
          <h2 class="text-transform text-white">Bổ sung giấy đăng ký kinh doanh</h2>
        </div>
      </div>
    </div>
    <section v-if="!gpdkkdData.id" class="login-area mix-dat">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container" style="max-width: 600px">
            <div class="card bg-white rounded-lg shadow-sm p-5">
              <div class="card-body">
                <h2 class="card-title font-weight-bold mb-2 text-center pb-3">
                  Xác thực thông tin
                </h2>
                <div class="py-3">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(verifyGpdkkd)">
                      <ValidationProvider rules="required" vid="email" name="Email">
                        <b-form-group slot-scope="{ errors }" label="Email (Đã đăng ký với MPOS)">
                          <b-form-input
                            v-model="checkValue"
                            autofocus
                            :state="errors[0] ? false : null"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                      <b-alert variant="danger" :show="errorMessage !== ''">{{
                        errorMessage
                      }}</b-alert>
                      <ul class="form-btn form-row m-t-20">
                        <li class="col-12">
                          <button type="submit" class="btn btn-success w-100" data-toggle="modal">
                            Xác nhận
                          </button>
                        </li>
                      </ul>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else class="container">
      <div class="breadcrumb-area p-0 pos-relative w-100">
        <h1>Xin chào quý khách, quý khách vui lòng kiểm tra thông tin và tải lên hồ sơ tại đây:</h1>
        <div style="float: right">
          <!-- <button
            v-if="canUpload"
            :disabled="(fileUploads.length == 0 || showLoading === true) && checkType === 2"
            @click="updateFile"
            class="btn btn-primary ml-2"
          >
            Gửi thông tin
          </button> -->
        </div>
      </div>
      <div class="card py-10 pt-15 b-t-1-869fb229 w-100">
        <div class="card-body form-row">
          <div class="col-sm-12 mb-3">
            <div class="form-detail border-none" style="font-size: 14px">
              <div class="form-group form-row">
                <label for="" class="col-sm-3 col-form-label"
                  >Đơn Vị Chấp Nhận Thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-9">
                  <p class="form-control-plaintext f12">
                    {{ gpdkkdData.merchantName }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-3 col-form-label"
                  >Địa chỉ<span class="float-right">:</span></label
                >
                <div class="col-sm-9">
                  <p class="form-control-plaintext f12">
                    {{ gpdkkdData.merchantAddress }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-3 col-form-label"
                  >Email<span class="float-right">:</span></label
                >
                <div class="col-sm-9">
                  <p class="form-control-plaintext f12">
                    {{ gpdkkdData.merchantEmail }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-3 col-form-label"
                  >Số điện thoại<span class="float-right">:</span></label
                >
                <div class="col-sm-9">
                  <p class="form-control-plaintext f12">
                    {{ gpdkkdData.merchantMobile }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mb-3">
            <div class="img-list-wrapper">
              <div class="mb-3" style="font-size: 14px; max-width: 700px">
                <h1 class="form-inner-heading">Hồ sơ bao gồm:</h1>
                a. Ảnh chụp giấy Đăng ký kinh doanh (Doanh nghiệp, Hộ kinh doanh cá thể...). <br />
                b. Ảnh chụp Chứng minh thư nhân dân hoặc Căn cước công dân của người đại diện pháp
                luật khớp với giấy Đăng ký kinh doanh.
                <div class="mt-2"></div>
                Trường hợp Chứng minh thư nhân dân/Căn cước công dân của Người đại diện pháp luật
                trên giấy phép khác với Người đại diện đã đăng ký trên tài khoản mPOS.vn, đề nghị
                Quý ĐVCNT cung cấp thêm ảnh chụp <b class="text-bold">giấy Ủy quyền</b> và ảnh chụp
                Chứng minh thư nhân dân/Căn cước công dân của người Ủy quyền.
                <!-- <p class="mt-2">Để được mPOS hỗ trợ, ĐVCNT vui lòng lựa chọn:</p>
                <div>
                  <label for="dkkd-radio-1" class="input-radio-dkkd">
                    <input type="radio" name="dkkd-radio" id="dkkd-radio-1" v-model="checkType" :value="1">
                    <span>Xin xác nhận gia hạn bổ sung Giấy Phép Đăng Ký Kinh Doanh trước ngày 31/05/2023</span>
                  </label>
                  <label for="dkkd-radio-2" class="input-radio-dkkd">
                    <input type="radio" name="dkkd-radio" id="dkkd-radio-2" v-model="checkType" :value="2">
                    <span>Đã có Giấy Phép Đăng Ký Kinh Doanh, xin bổ sung ngay.</span>
                  </label>
                </div> -->
              </div>
              <template v-if="checkType === 2">
                <h1 class="form-inner-heading mt-2">Tải ảnh lên</h1>
                <div class="form-group img-list">
                  <ul class="m-0">
                    <li v-for="(item, index) in fileUploads" :key="index">
                      <a href="javascript:void(0)">
                        <img :src="item.url" />
                        <span v-if="canUpload" @click="removeFile(item.id)">
                          <i class="bx bx-trash bx-sm"></i>
                        </span>
                      </a>
                    </li>
                    <li>
                      <div v-if="canUpload && fileUploads.length < 10" class="add-img">
                        <span class="bx bx-plus text-center"></span>
                        <input
                          type="file"
                          ref="transImage"
                          accept="image/jpeg, image/png"
                          @change="uploadImage($event, 'transImage')"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <button
                  v-if="canUpload"
                  :disabled="(fileUploads.length == 0 || showLoading === true) && checkType === 2"
                  @click="updateFile"
                  class="btn btn-primary"
                >
                  Gửi thông tin
                </button>

                <h1 class="form-inner-heading mt-3">Lưu ý:</h1>
                <div>
                  <div style="font-size: 14px; max-width: 700px">
                    I/ Quý ĐVCNT có thể xem chi tiết công văn v.v bổ sung hồ sơ
                    <a
                      href="https://drive.google.com/file/d/1YFREpeG0oUCUqGpmdTeBALsxECpVcXx0/view?pli=1"
                      target="_blank"
                      class="text-bold text-link"
                      >tại đây</a
                    >.
                    <div class="mt-2"></div>
                    II/ Hạn cuối cung cấp và bổ sung hồ sơ đăng ký kinh doanh: Đến hết ngày
                    <b class="text-bold">20/08/2023</b>.
                    <div class="mt-2"></div>
                    Sau thời hạn trên, nếu Quý ĐVCNT không cung cấp đủ hồ sơ bổ sung, Ngân hàng sẽ
                    <b class="text-danger">TỪ CHỐI HỖ TRỢ</b> thanh toán và
                    <b class="text-danger">KHÓA TÀI KHOẢN</b> chấp nhận thanh toán thẻ.
                    <div class="mt-2"></div>
                    Trường hợp muốn mở lại tài khoản, Quý ĐVCNT vui lòng liên hệ
                    <b class="text-bold">Bộ phận kinh doanh</b> hoặc số hotline
                    <b class="text-bold">1900.63.64.88</b> hoặc email
                    <b class="text-bold">hotro@mpos.vn</b> và cung cấp hồ sơ theo quy định.<br />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="bg-ef">
      <div class="container">
        <div class="footer-mcct">
          <p class="t">CÔNG TY CỔ PHẦN CÔNG NGHỆ VIMO</p>
          <p class="i">
            <i
              >Tầng 12A, tòa nhà VTC Online, số 18 Tam Trinh, phường Tương Mai, thành phố Hà Nội,
              Việt Nam</i
            >
          </p>
          <p class="i">
            <i>Hotline: 1900.63.64.88 | Email: hotro@mpos.vn</i>
          </p>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { GPDKKDService } from '@/services/gpdkkd.service'
  import Config from '@/thirdParty/config'
  import { v4 as uuidv4 } from 'uuid'
  export default {
    data() {
      return {
        Config,
        gpdkkdData: {},
        showLoading: false,
        errorMessage: '',
        checkValue: '',
        checkType: 2,
        fileUploads: [],
      }
    },
    computed: {
      canUpload: vm => !vm.gpdkkdData.isMcUploadPhoto,
    },
    methods: {
      async verifyGpdkkd() {
        try {
          this.showLoading = true
          const res = await GPDKKDService.verifyGPDKKD({
            mcEmail: this.checkValue.trim(),
            stickerId: this.$route.params.stickerId,
          })
          if (res.data.success === true) {
            this.errorMessage = ''
            await this.getDetailMerchant(this.checkValue.trim())
          } else this.errorMessage = 'Email không khớp với thông tin trên hợp đồng!'
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getDetailMerchant(mcEmail) {
        const resGpdkkd = await GPDKKDService.detailMerchant({
          mcEmail: this.gpdkkdData.merchantEmail ?? mcEmail,
          stickerId: this.$route.params.stickerId,
        })
        if (resGpdkkd.data.success === true) {
          this.gpdkkdData = resGpdkkd.data.data
        }

        this.fileUploads = []
        const mappingData = (arr, type) =>
          arr.forEach(url => {
            const ar = { name: url, url, type, id: uuidv4() }
            this.fileUploads.push(ar)
          })
        mappingData(this.gpdkkdData.mcUploadImages, 'transImage')
      },
      uploadFile(e, type) {
        const file = e.target.files[0]
        if (file.size > 20 * 1024 * 1024) {
          alert('Upload tối đa 20MB')
          return
        }
        this.fileUploads.push({
          id: uuidv4(),
          name: file.name,
          file,
          type,
        })
        this.$refs[type].value = null
      },
      uploadImage(e, type) {
        const file = e.target.files[0]
        this.fileUploads.push({
          id: uuidv4(),
          name: file.name,
          url: URL.createObjectURL(file),
          file,
          type,
        })
        this.$refs[type].value = null
      },
      removeFile(id) {
        this.fileUploads = this.fileUploads.filter(s => s.id !== id)
      },
      async sendFile(item) {
        if (item.file) {
          const formData = new FormData()
          formData.append('file', item.file)
          const data = await GPDKKDService.uploadFileMerchant(formData)
          const urlFile = data.data.urlFile
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      async totalSubmit() {
        const allPromises = this.fileUploads.map(s => this.sendFile(s))
        return Promise.all(allPromises).then(res => {
          const returnData = {
            images: [],
          }
          res.forEach(s => {
            if (s?.urlFile) {
              if (s.type === 'transImage') {
                returnData.images.push(s.urlFile)
              }
            }
          })
          return returnData
        })
      },
      async updateFile() {
        try {
          this.showLoading = true
          if (this.checkType === 2) {
            const params = await this.totalSubmit()
            const data = await GPDKKDService.updateUrl({
              ...params,
              stickerId: this.$route.params.stickerId,
              mcEmail: this.gpdkkdData.merchantEmail,
            })
            if (data.success) {
              this.gpdkkdData.isMcUploadPhoto = true
              this.showSuccessMx('Bổ sung giấy phép đăng ký kinh doanh thành công')
            } else {
              this.showFailMx(data.message)
            }
          } else {
            const data = await GPDKKDService.bsGPLater({
              stickerId: this.$route.params.stickerId,
            })
            if (data.success) {
              this.showSuccessMx('Xin xác nhận gia hạn bổ sung giấy phép ĐKKD thành công').then(s =>
                window.close()
              )
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (e) {
          console.log(e)
          this.showFailMx('Bổ sung giấy phép đăng ký kinh doanh thất bại')
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header-mcct {
    padding: 25px 0;
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    align-items: center;
    justify-items: center;
    gap: 30px;
    h2 {
      font-size: 32px;
      text-align: center;
    }
  }
  .bg-hrad {
    background-color: #d1232c;
    border-bottom: 7px solid #eb9422;
  }
  .bg-ef {
    background-color: #efefef;
  }
  .text-danger {
    font-family: 'Roboto-Medium';
    font-weight: bolder !important;
  }
  .text-bold {
    color: #000 !important;
    font-weight: bolder !important;
    font-family: 'Roboto-Medium';
  }
  .text-link {
    font-family: 'Roboto-Medium';
    cursor: pointer !important;
    text-decoration: underline !important;
  }
  .footer-mcct {
    padding: 25px 0;
    display: flex;
    flex-direction: column;
    p {
      line-height: normal;
    }
    .i {
      font-size: 11px;
    }
  }
  @media (min-width: 768px) {
    .header-mcct {
      grid-template-columns: auto 1fr;
      img {
        display: block;
      }
      h2 {
        font-size: 36px;
      }
    }
  }
  .input-radio-dkkd {
    &:has(input:checked) {
      border: 2px solid #59a9ff;
    }
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 12px;
    input {
      margin-right: 6px;
      width: auto;
      flex-shrink: unset;
    }
    span {
      font-weight: 500;
      color: black;
    }
  }
</style>
